import BannerAbstract from './BannerAbstract'
import Filters from '../abstracts/Filters'

export default class ModalBanner extends BannerAbstract {
  constructor(parameters, LanguageManager) {
    super(parameters, LanguageManager)

    // config
    this.key = 'modale'
    this.type = 'panel'
    this.content = this.getContent()

    // events
    this.events()
  }

  getHtmlId() {
    return 'rousquille'
  }

  getContent() {
    // force LanguageManager to initialize its translations before we start using them
    const translations = this.LanguageManager.getTranslations()

    // build banner element markup
    const htmlId = this.getHtmlId()
    let html = ''
    html += `  <div id="${this.getHtmlId()}Wrapper" class="rsq-overlay"></div>`
    html += `  <button id="rousquilleClosePanel" class="btn default" title="${translations.closeTitle}">${translations.close}</button>`
    html += '  <div id="rousquilleServices">'
    html += '    <header>'
    html += `      <strong class="h1" role="heading" aria-level="1" id="dialogTitle">${translations.title}</strong>`
    html += `      <div class="info">${translations.disclaimer}`

    if (this.parameters.privacyUrl !== '') {
      html += `      <a class="link link-privacy" href="#">${translations.privacyUrl}</a>`
    }

    html += '      </div>'
    html += '      <div class="actions">'
    html += `        <button class="btn btnAll allowAll allow">${translations.allowAll}</button>`

    if (this.parameters.denyAllCta) {
      html += `        <button class="btn btnAll denyAll deny">${translations.denyAll}</button>`
    }

    html += '      </div>'
    html += '    </header>'
    html += '    <div class="content-inner">'
    html += '      <ul id="rousquilleGroups">'

    for (const group of this.GroupManager.groups) {
      html += `      <li id="group-${group.key}" class="group rousquilleHidden">`
      html += '        <div class="info">'
      html += `          <div class="label">${typeof translations[group.key] !== 'undefined' ? translations[group.key].title : group.name}</div>`
      html += `          <div class="details">${typeof translations[group.key] !== 'undefined' ? translations[group.key].details : group.description}</div>`
      html += '        </div>'
      html += '        <ul class="services"></ul>'
      html += '      </li>'
    }

    html = String(html)
    html += '      </ul>'
    html += '    </div>'

    if (this.parameters.removeCredit === false) {
      html += '    <footer>'
      html += `    <a class="link" href="https://www.nematis.com/" rel="nofollow noopener" target="_blank" title="Nematis ${translations.newWindow}">${translations.credit}</a>`
      html += '    </footer>'
    }

    html += '  </div>'

    let modalBannerEl = document.createElement('div')
    modalBannerEl.id = htmlId
    modalBannerEl.setAttribute('role', 'dialog')
    modalBannerEl.setAttribute('aria-labelled-by', 'dialogTitle')
    modalBannerEl.classList.add('alert', this.parameters.orientation)
    modalBannerEl.innerHTML = html

    // allow external components to filter banner element before display
    modalBannerEl = Filters.applyFilters('banners.services.domElement', modalBannerEl)

    return modalBannerEl.outerHTML
  }

  events() {
    document.addEventListener('rsq.manager.banner.build', () => {
      const thisModal = this

      // close modal
      document.querySelector('#rousquilleWrapper').addEventListener('click', () => {
        thisModal.close()
      })
      document.querySelector('#rousquilleClosePanel').addEventListener('click', () => {
        thisModal.close()
      })

      // allowAll
    }, false)
  }
}
